<div class="row devOptions"  *ngIf="showDevOptions&&devOptionsRight">
  <ul class="nav nav-tabs in">
    <li [class.active]="state.tabs.demo1=='0'">
      <a (click)="state.tabs.demo1 = '0'">
        <span>{{'common_all_decode' | i18n}} </span>
      </a>
    </li>
    <li [class.active]="state.tabs.demo1=='1'">
      <a (click)="state.tabs.demo1 = '1'">
        <span> {{'translation' | i18n}}</span>
      </a>
    </li>
    <i class="fa fa-window-minimize pull-right margin-top-10 margin-right-8" (click)="showDevOptions=false" style="cursor: pointer;"></i>
  </ul>

  <tabset class="padding-10">
    <tab [active]="state.tabs.demo1 == 0">
      <textarea class="decodeTextArea" id="encrypted" placeholder="{{'common_all_encryptedData' | i18n}}"></textarea>
      <textarea class="decodeTextArea" id="decrypted" placeholder="{{'common_all_result' | i18n}}" disabled></textarea>
      <div class="clearfix"></div>
      <hr>
      <div class="col-sm-12 text-right">
        <footer>
          <button title="{{'common_clear' | i18n}}" (click)="clear()"
            class="btn btn-danger margin-right-8 search-btn">{{'common_clear' | i18n}}</button>
          <button title="{{'common_submit' | i18n}}" (click)="decode()" type="button"
            class="btn btn-primary search-btn"><i class="fa fa-spinner fa-spin"
              *ngIf="addStatus"></i>{{'common_submit' | i18n}}</button>
        </footer>
      </div>
    </tab>
    <tab [active]="state.tabs.demo1 == 1" style="color:#333;padding: 0px 15px;"> 
      Will be updated soon
    </tab>
  </tabset>
</div>
<div class="page-footer asidePanel">
    <div class="row">
        <div class="col-xs-12 col-md-3 col-lg-2 clear-cache pr-0">
            <a title="{{'settings_common_clearcache' | i18n}}" (click)="factoryReset()" class="menuTooltip clearCacheButton" id="reset-smart-widget">
                <span class="clearcachelink"><i class="fa fa-lg fa-refresh"></i>
					{{'settings_common_clearcache' | i18n}}</span></a>
        </div>
        <div class="col-xs-12 col-md-9 col-lg-7 copyright px-0">
            <ul class="footer-menu">
                <li>&copy; {{year}} iomarket</li>
                <li><a href="https://www.io-market.com/AGB.pdf" title="{{'common_all_terms_and_conditions' | i18n}}" target="_blank">{{'common_all_terms_and_conditions' | i18n}}</a></li>
                <li><a href="https://www.io-market.com/ADV.pdf" title="{{'common_all_data_processing_agreement' | i18n}}" target="_blank">{{'common_all_data_processing_agreement' | i18n}}</a></li>
                <li><a href="https://www.io-market.com/privacy_policy.pdf" title="{{'common_all_privacy_policy' | i18n}}" target="_blank">{{'common_all_privacy_policy' | i18n}}</a></li>
                <li><a href="https://www.io-market.com/impressum.pdf" title="{{'common_all_legal_notices' | i18n}}" target="_blank">{{'common_all_legal_notices' | i18n}}</a></li>
            </ul>
        </div>
        <div class="col-xs-12 col-md-12 col-lg-3 powerd-by pl-0">
          <div class="row">
            <div class="col-xs-12  col-md-6">
              <!-- <a title="{{'common_download' | i18n}}" class="btn btn-primary margin-right-8 showDownloadCenter fixTopOfFooter"  style="width: 50px;  margin-top: -6px;"> 
                <i class="fa fa-download"></i>
              </a> -->
              <a title="{{'common_all_decode' | i18n}}" *ngIf="devOptionsRight" (click)="openDevOption()" class="btn btn-primary margin-right-8 dev-option" id="reset-smart-widget" [style.background-color]="showDevOptions?'#0c7cd5':'#2196F3'">
            	<span class="decode">{{'common_all_footer_devOptions' | i18n}}</span></a>
            </div>
            <div class="col-xs-12  col-md-6">
              <span>{{'common_all_footer_phrase' | i18n}}</span>
            </div>
          </div>
        </div>
    </div>
</div>
